import React, { useEffect, useState } from 'react'
import { Consent } from '../../common/Enums'
import SettingsStore, {
    SettingsStoreState,
} from '../../flux/settings/SettingsStore'
import { setCookieConsent } from '../../flux/settings/SettingsActions'
import CookiesConsentModalComponent from './CookiesConsentModal'
import { isLocalStorageAvailable } from '../../repositories/LocalStorageUtilities'

/**
 * Determines if the user needs to be prompted to accept or decline cookies.
 *
 * @returns {JSX.Element} React control cookies consent component
 */
function ControlCookiesConsent() {
    const settingsStore = SettingsStore.GetInstance()
    const [isInitialized, setIsInitialized] = useState(
        settingsStore.State === SettingsStoreState.Loaded
    )

    /**
     * Handles consent response from modal
     * @param {Consent} value Accepted or Declined
     */
    function handleConsent(value: Consent) {
        setCookieConsent(value)
    }

    useEffect(() => {
        /**
         * Invoked if the state of the settings store had changed
         */
        function handleSettingsStoreChange() {
            setIsInitialized(settingsStore.State === SettingsStoreState.Loaded)
        }

        if (isLocalStorageAvailable() && !isInitialized)
            settingsStore.addChangeListener(handleSettingsStoreChange)

        return () => {
            if (
                !isInitialized &&
                settingsStore.State === SettingsStoreState.Loaded
            )
                settingsStore.removeChangeListener(handleSettingsStoreChange)
        }
    }, [isInitialized, settingsStore])

    if (
        !isLocalStorageAvailable() ||
        !isInitialized ||
        settingsStore.CookieConsent !== Consent.Undecided
    )
        return <></>
    return <CookiesConsentModalComponent onConsent={handleConsent} />
}

export default ControlCookiesConsent
